<ion-header translucent="true">
    <ion-toolbar>
        <ion-title>Progress</ion-title>
    </ion-toolbar>
</ion-header>
<ion-content fullscreen>
    <ion-text>
        <h1>LEVEL 5</h1>
    </ion-text>
    <br>
    <ion-list>
        <ion-list-header>Achievements</ion-list-header>

        <ion-item>
            <ion-avatar slot="start">
                <img src="res/award_small.png" alt=""/>
            </ion-avatar>
            <ion-label>
                <h2>August</h2>
                <p>August survey completed</p>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-avatar slot="start">
                <img src="res/alpaca.jpg" alt=""/>
            </ion-avatar>
            <ion-label>
                <h2>Every Week</h2>
                <p>Answered questions every week</p>
            </ion-label>
        </ion-item>
        <ion-item>
            <ion-avatar slot="start">
                <img src="res/five.png" alt=""/>
            </ion-avatar>
            <ion-label>
                <h2>Five Categories</h2>
                <p>Answered questions in five categories</p>
            </ion-label>
        </ion-item>
    </ion-list>
</ion-content>

<style>
    h1 {
        text-align: center;
    }
</style>
